import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NavigationService} from '@ngx-seatback/utils';
import {UtilService} from '../../../services/util.service';

@Component({
  selector: 'app-media-overview',
  templateUrl: './media-overview.component.html',
  styleUrls: ['./media-overview.component.scss'],
  standalone: false,
})
export class MediaOverviewComponent implements OnInit {
  constructor(
    private router: Router,
    private navService: NavigationService,
    public util: UtilService
  ) {}

  ngOnInit() {
    this.navService.navigateToPoint(this.util.RoutingID.mediumExplorer);
  }
}
